import { Sport } from "../../redux/slices";
import { PlayBase } from "./generic-play";

export enum HockeyRinkView {
  FULL = "FULL",
  LEFT_RINK = "LEFT-RINK",
  RIGHT_RINK = "RIGHT-RINK",
  GOAL = "GOAL",
  LEFT_ONE_THIRD = "LEFT-ONE-THIRD",
  RIGHT_ONE_THIRD = "RIGHT-ONE-THIRD",
  LEFT_TWO_THIRD = "LEFT-TWO-THIRD",
  RIGHT_TWO_THIRD = "RIGHT-TWO-THIRD",
}

export interface HockeyPlay extends PlayBase<HockeyRinkView> {
  sport: Sport.HOCKEY;
}
